import teamService from '../../services/team-members-service';
import {
  LOAD_DEAL_TEAM_SUCCESS,
  LOAD_DEAL_TEAM_FAILURE,
  LOAD_ADMIN_DEAL_MEMBERS_SUCCESS,
  LOAD_ADMIN_DEAL_MEMBERS_FAILURE,
  UPDATE_ADMIN_DEAL_MEMBERS_SUCCESS,
  UPDATE_ADMIN_DEAL_MEMBERS_FAILURE,
  LOAD_COMMISSION_TEAM_SUCCESS,
  UPDATE_DEAL_USERS_SUCCESS,
  UPDATE_COMMISSION_USERS_SUCCESS,
  UPDATE_DEAL_USERS_FAILURE,
  UPDATE_DEAL_TEAMS_SUCCESS,
  UPDATE_MANAGE_DEAL_TEAMS_FAILURE,
  UPDATE_MANAGE_DEAL_TEAMS_SUCCESS,
  UPDATE_COMMISSION_TEAMS_SUCCESS,
  UPDATE_DEAL_TEAMS_FAILURE,
  LOAD_ADMIN_COMMISSION_MEMBERS_FAILURE,
  LOAD_ADMIN_COMMISSION_MEMBERS_SUCCESS,
  UPDATE_ADMIN_COMMISSION_USERS_SUCCESS,
  UPDATE_ADMIN_COMMISSION_USERS_FAILURE,
  UPDATE_USER
} from './action-types';
import { toast } from './toasts-actions';

import userEventService from '../../services/user-event-service';

const analyticProperties = {
  actionPrefix: 'deal_member_',
  category: 'Deal Membership',
};

// Team Actions Creators
const loadDealTeamSuccess = teamMembers => ({
  type: LOAD_DEAL_TEAM_SUCCESS,
  payload: { teamMembers },
});

const loadAdminDealMembersSuccess = teamMembers => ({
  type: LOAD_ADMIN_DEAL_MEMBERS_SUCCESS,
  payload: { teamMembers },
});

const loadAdminDealMembersFailure = error => ({
  type: LOAD_ADMIN_DEAL_MEMBERS_FAILURE,
  payload: { error },
});

const loadAdminCommissionMembersSuccess = teamMembers => ({
  type: LOAD_ADMIN_COMMISSION_MEMBERS_SUCCESS,
  payload: { teamMembers },
});

const loadAdminCommissionMembersFailure = error => ({
  type: LOAD_ADMIN_COMMISSION_MEMBERS_FAILURE,
  payload: { error },
});

const loadDealTeamFailure = error => ({
  type: LOAD_DEAL_TEAM_FAILURE,
  payload: { error },
});

const loadCommissionTeamSuccess = teamMembers => ({
  type: LOAD_COMMISSION_TEAM_SUCCESS,
  payload: { teamMembers },
});

const updateDealUsersSuccess = data => ({
  type: UPDATE_DEAL_USERS_SUCCESS,
  payload: { ...data },
});

const updateAdminDealMembersSuccess = data => ({
  type: UPDATE_ADMIN_DEAL_MEMBERS_SUCCESS,
  payload: { ...data },
});

const updateAdminCommissionUsersSuccess = data => ({
  type: UPDATE_ADMIN_COMMISSION_USERS_SUCCESS,
  payload: { ...data },
});

const updateAdminDealMembersFailure = error => ({
  type: UPDATE_ADMIN_DEAL_MEMBERS_FAILURE,
  payload: { error },
});

const updateAdminCommissionUsersFailure = error => ({
  type: UPDATE_ADMIN_COMMISSION_USERS_FAILURE,
  payload: { error },
});

const updateManageDealTeamsSuccess = data => ({
  type: UPDATE_MANAGE_DEAL_TEAMS_SUCCESS,
  payload: { ...data },
});

const updateCommissionUsersSuccess = data => ({
  type: UPDATE_COMMISSION_USERS_SUCCESS,
  payload: { ...data },
});

const updateDealUsersFailure = error => ({
  type: UPDATE_DEAL_USERS_FAILURE,
  payload: { error },
});

const updateDealTeamsSuccess = data => ({
  type: UPDATE_DEAL_TEAMS_SUCCESS,
  payload: { ...data },
});

const updateManageDealTeamsFailure = error => ({
  type: UPDATE_MANAGE_DEAL_TEAMS_FAILURE,
  payload: { error },
});

const updateCommissionTeamsSuccess = data => ({
  type: UPDATE_COMMISSION_TEAMS_SUCCESS,
  payload: { ...data },
});

const updateDealTeamsFailure = error => ({
  type: UPDATE_DEAL_TEAMS_FAILURE,
  payload: { error },
});

// ASYNC ACTIONS:
const loadDealTeam = params => dispatch =>
  teamService.getDealTeam(params)
    .then((data) => {
      dispatch(loadDealTeamSuccess(data.results));
    })
    .catch(error => dispatch(loadDealTeamFailure(error)));

const loadAdminDealMembers = params => dispatch =>
  teamService.getAdminDealMembers(params)
    .then((data) => {
      dispatch(loadAdminDealMembersSuccess(data.results));
    })
    .catch(error => dispatch(loadAdminDealMembersFailure(error)));

const loadAdminCommissionMembers = params => dispatch =>
  teamService.getAdminCommissionMembers(params)
    .then((data) => {
      dispatch(loadAdminCommissionMembersSuccess(data.results));
    })
    .catch(error => dispatch(loadAdminCommissionMembersFailure(error)));

const loadCommissionTeam = params => dispatch =>
  teamService.getDealTeam(params)
    .then((data) => {
      dispatch(loadCommissionTeamSuccess(data.results));
    })
    .catch(error => dispatch(loadDealTeamFailure(error)));

const addDealMember = data => dispatch =>
  teamService.addDealMember(data)
    .then((result) => {
      dispatch(updateDealUsersSuccess(result));
      userEventService.trackEvent({
        eventAction: `${analyticProperties.actionPrefix}add_user`,
        eventCategory: analyticProperties.category,
        eventLabel: `${analyticProperties.actionPrefix}add_user`,
        eventValue: result.user.id,
        eventData: {
          deal_pk: result.deal,
          user_pk: result.user.id,
        },
      });
    })
    .catch(error => dispatch(updateDealUsersFailure(error)));

const addAdminDealMember = data => dispatch =>
  teamService.addAdminDealMember(data)
    .then((result) => {
      dispatch(updateAdminDealMembersSuccess(result));
      userEventService.trackEvent({ // TO DO 
        eventAction: `${analyticProperties.actionPrefix}add_admin_user`,
        eventCategory: analyticProperties.category,
        eventLabel: `${analyticProperties.actionPrefix}add_admin_user`,
        eventValue: result.user.id,
        eventData: {
          deal_pk: result.deal,
          user_pk: result.user.id,
        },
      });
    })
    .catch(error => dispatch(updateAdminDealMembersFailure(error)));
  
const addAllAdminDealMembers = (deal, userIds) => dispatch => {
  userIds.forEach(userId =>
    dispatch(addAdminDealMember({
      deal,
      team_id: null,
      user_id: userId,
    })));
};

const addAdminCommissionMember = data => dispatch =>
  teamService.addAdminCommissionMember(data)
    .then((result) => {
      dispatch(updateAdminCommissionUsersSuccess(result));
      userEventService.trackEvent({
        eventAction: `${analyticProperties.actionPrefix}add_admin_commission_user`,
        eventCategory: analyticProperties.category,
        eventLabel: `${analyticProperties.actionPrefix}add_admin_commission_user`,
        eventValue: result.user.id,
        eventData: {
          deal_pk: result.deal,
          user_pk: result.user.id,
        },
      });
    })
    .catch(error => dispatch(updateAdminCommissionUsersFailure(error)));
  
const addAllAdminCommissionMembers = (deal, userIds) => dispatch => {
  userIds.forEach(userId =>
    dispatch(addAdminCommissionMember({
      deal,
      team_id: null,
      user_id: userId,
    })));
};

const addDealMembers = (deal, userIds) => dispatch => {
  const dealId = typeof deal === 'object' && deal !== null ? deal.id : deal;
  if (!dealId) {
    console.warn('addDealMembers: deal is undefined or missing id');
    return;
  }
  userIds.forEach(userId =>
    dispatch(addDealMember({
      deal: dealId,
      team_id: null,
      user_id: userId,
    })));
};

const addCommissionMember = data => dispatch =>
  teamService.addDealMember(data)
    .then((result) => {
      dispatch(updateCommissionUsersSuccess(result));
      userEventService.trackEvent({
        eventAction: `${analyticProperties.actionPrefix}add_commission_user`,
        eventCategory: analyticProperties.category,
        eventLabel: `${analyticProperties.actionPrefix}add_commission_user`,
        eventValue: result.user.id,
        eventData: {
          deal_pk: result.deal,
          user_pk: result.user.id,
        },
      });
    })
    .catch(error => dispatch(updateDealUsersFailure(error)));

const addCommissionMembers = (deal, userIds) => dispatch =>
  userIds.forEach(userId =>
    dispatch(addCommissionMember({
      deal,
      team_id: null,
      user_id: userId,
    })));

const addDealTeam = data => dispatch =>
  teamService.addDealMember(data)
    .then((result) => {
      dispatch(updateDealTeamsSuccess(result));
      userEventService.trackEvent({
        eventAction: `${analyticProperties.actionPrefix}add_team`,
        eventCategory: analyticProperties.category,
        eventLabel: `${analyticProperties.actionPrefix}add_team`,
        eventValue: result.team.id,
        eventData: {
          deal_pk: result.deal,
          team_pk: result.team.id,
        },
      });
    })
    .catch(error => dispatch(updateDealTeamsFailure(error)));

const addDealTeams = (deal, teamIds) => dispatch =>
  teamIds.forEach(teamId =>
    dispatch(addDealTeam({
      deal,
      team_id: teamId,
      user_id: null,
    })));

const addManageDealTeam = data => dispatch =>
  teamService.addAdminDealMember(data)
    .then((result) => {
      dispatch(updateManageDealTeamsSuccess(result));
      userEventService.trackEvent({
        eventAction: `${analyticProperties.actionPrefix}add_manage_team`,
        eventCategory: analyticProperties.category,
        eventLabel: `${analyticProperties.actionPrefix}add_manage_team`,
        eventValue: result.team.id,
        eventData: {
          deal_pk: result.deal,
          team_pk: result.team.id,
        },
      });
    })
    .catch(error => dispatch(updateManageDealTeamsFailure(error)));

const addManageDealTeams = (deal, teamIds) => dispatch =>
  teamIds.forEach(teamId =>
    dispatch(addManageDealTeam({
      deal,
      team_id: teamId,
      user_id: null,
    })));

const addCommissionTeam = data => dispatch =>
  teamService.addDealMember(data)
    .then((result) => {
      dispatch(updateCommissionTeamsSuccess(result));
      userEventService.trackEvent({
        eventAction: `${analyticProperties.actionPrefix}add_commission_team`,
        eventCategory: analyticProperties.category,
        eventLabel: `${analyticProperties.actionPrefix}add_commission_team`,
        eventValue: result.team.id,
        eventData: {
          deal_pk: result.deal,
          team_pk: result.team.id,
        },
      });
    })
    .catch(error => dispatch(updateDealTeamsFailure(error)));

const addCommissionTeams = (deal, teamIds) => dispatch =>
  teamIds.forEach(teamId =>
    dispatch(addCommissionTeam({
      deal,
      team_id: teamId,
      user_id: null,
    })));

const removeDealMember = (dealMemberId, dealId) => dispatch =>
  teamService.removeDealMember(dealMemberId)
    .then((data) => {
      dispatch(updateDealUsersSuccess(data));
      userEventService.trackEvent({
        eventAction: `${analyticProperties.actionPrefix}remove_user`,
        eventCategory: analyticProperties.category,
        eventLabel: `${analyticProperties.actionPrefix}remove_user`,
        eventValue: data.id,
        eventData: {
          deal_pk: dealId,
          user_pk: data.id,
        },
      });
    })
    .catch((error) => {
      dispatch(updateDealUsersFailure(error));
      dispatch(toast('Error Removing Deal Collaborator'));
    });

const removeAdminDealMember = (dealMemberId, dealId) => dispatch =>
  teamService.removeAdminDealMember(dealMemberId, dealId)
    .then((data) => {
      dispatch(updateAdminDealMembersSuccess({...data, method: 'DELETE'}));
      userEventService.trackEvent({
        eventAction: `${analyticProperties.actionPrefix}admin_remove_user`,
        eventCategory: analyticProperties.category,
        eventLabel: `${analyticProperties.actionPrefix}admin_remove_user`,
        eventValue: data.id,
        eventData: {
          deal_pk: dealId,
          user_pk: data.id,
        },
      });
    })
    .catch((error) => {
      dispatch(updateAdminDealMembersFailure(error));
      dispatch(toast('Error Removing Deal Collaborator'));
    });
 

const removeDealMembers = (dealMemberIds, dealId) => dispatch =>
  dealMemberIds.forEach(dealMemberId =>
    dispatch(removeDealMember(dealMemberId, dealId)));

const removeAdminDealMembers = (dealMemberIds, dealId) => dispatch =>
  dealMemberIds.forEach(dealMemberId =>
    dispatch(removeAdminDealMember(dealMemberId, dealId)));

const removeAdminCommissionMember = (commissionMemberId, dealId) => dispatch =>
  teamService.removeAdminCommissionMember(commissionMemberId, dealId)
    .then((data) => {
      dispatch(updateAdminCommissionUsersSuccess({...data, method: 'DELETE'}));
      userEventService.trackEvent({
        eventAction: `${analyticProperties.actionPrefix}remove_admin_commission_user`,
        eventCategory: analyticProperties.category,
        eventLabel: `${analyticProperties.actionPrefix}remove_admin_commission_user`,
        eventValue: data.id,
        eventData: {
          deal_pk: dealId,
          user_pk: data.id,
        },
      });
    })
    .catch((error) => {
      dispatch(updateAdminCommissionUsersFailure(error));
      dispatch(toast('Error Removing Commission User'));
    });

const removeAdminCommissionMembers = (commissionMemberIds, dealId) => dispatch =>
  commissionMemberIds.forEach(commissionMemberId =>
    dispatch(removeAdminCommissionMember(commissionMemberId, dealId)));

const removeCommissionMember = (commissionMemberId, dealId) => dispatch =>
  teamService.removeDealMember(commissionMemberId)
    .then((data) => {
      dispatch(updateCommissionUsersSuccess(data));
      userEventService.trackEvent({
        eventAction: `${analyticProperties.actionPrefix}remove_commission_user`,
        eventCategory: analyticProperties.category,
        eventLabel: `${analyticProperties.actionPrefix}remove_commission_user`,
        eventValue: data.id,
        eventData: {
          deal_pk: dealId,
          user_pk: data.id,
        },
      });
    })
    .catch((error) => {
      dispatch(updateDealUsersFailure(error));
      dispatch(toast('Error Removing Deal Collaborator'));
    });

const removeCommissionMembers = (commissionMemberIds, dealId) => dispatch =>
  commissionMemberIds.forEach(commissionMemberId =>
    dispatch(removeCommissionMember(commissionMemberId, dealId)));

const removeDealTeam = (dealTeamId, dealId) => dispatch =>
  teamService.removeDealMember(dealTeamId)
    .then((data) => {
      dispatch(updateDealTeamsSuccess(data));
      userEventService.trackEvent({
        eventAction: `${analyticProperties.actionPrefix}remove_team`,
        eventCategory: analyticProperties.category,
        eventLabel: `${analyticProperties.actionPrefix}remove_team`,
        eventValue: data.id,
        eventData: {
          deal_pk: dealId,
          team_pk: data.id,
        },
      });
    })
    .catch(error => dispatch(updateDealTeamsFailure(error)));

const removeDealTeams = (dealTeamIds, dealId) => dispatch =>
  dealTeamIds.forEach(dealTeamId =>
    dispatch(removeDealTeam(dealTeamId, dealId)));

const removeAdminDealTeam = (dealTeamId, dealId) => dispatch =>
  teamService.removeAdminDealMember(dealTeamId, dealId)
    .then((data) => {
      dispatch(updateManageDealTeamsSuccess({...data, method: 'DELETE'}));
      userEventService.trackEvent({
        eventAction: `${analyticProperties.actionPrefix}remove_admin_team`,
        eventCategory: analyticProperties.category,
        eventLabel: `${analyticProperties.actionPrefix}remove_admin_team`,
        eventValue: data.id,
        eventData: {
          deal_pk: dealId,
          team_pk: data.id,
        },
      });
    })
    .catch(error => dispatch(updateAdminDealTeamsFailure(error)));

const removeAdminDealTeams = (dealTeamIds, dealId) => dispatch =>
  dealTeamIds.forEach(dealTeamId =>
    dispatch(removeAdminDealTeam(dealTeamId, dealId)));

const removeCommissionTeam = (dealTeamId, dealId) => dispatch =>
  teamService.removeDealMember(dealTeamId)
    .then((data) => {
      dispatch(updateCommissionTeamsSuccess(data));
      userEventService.trackEvent({
        eventAction: `${analyticProperties.actionPrefix}remove_commission_team`,
        eventCategory: analyticProperties.category,
        eventLabel: `${analyticProperties.actionPrefix}remove_commission_team`,
        eventValue: data.id,
        eventData: {
          deal_pk: dealId,
          team_pk: data.id,
        },
      });
    })
    .catch(error => dispatch(updateDealTeamsFailure(error)));

const removeCommissionTeams = (dealTeamIds, dealId) => dispatch =>
  dealTeamIds.forEach(dealTeamId =>
    dispatch(removeCommissionTeam(dealTeamId, dealId)));

const updateUser = (user) => ({
  type: UPDATE_USER,
  payload: user
});

export {
  loadDealTeam,
  loadAdminDealMembers,
  loadCommissionTeam,
  addDealMember,
  addAllAdminDealMembers,
  addDealMembers,
  addCommissionMember,
  addCommissionMembers,
  removeDealMember,
  removeDealMembers,
  removeAdminDealMembers,
  addDealTeam,
  addDealTeams,
  addCommissionTeam,
  addCommissionTeams,
  removeCommissionMember,
  removeCommissionMembers,
  removeDealTeam,
  removeDealTeams,
  removeCommissionTeam,
  removeCommissionTeams,
  addManageDealTeams,
  removeAdminDealTeams,
  loadAdminCommissionMembers,
  addAllAdminCommissionMembers,
  removeAdminCommissionMembers,
  updateUser
};
